import * as React from "react";
import { Button, Text } from "@uikit";
import { Breadcrumb } from "@kalabo/golfsavers-common";
import { Link, navigate } from "gatsby";
import { SearchCircleIcon, SearchIcon } from "@heroicons/react/outline";
import CommandPalette from "../commandPalette";

interface iBreadcrumbProps {
  breadcrumb: Breadcrumb[];
  hideSearch?: boolean;
  region_id?: string;
  mode?: "simple" | "full";
  theme?: "light" | "dark";
}

const BreadcrumbComponent = ({
  breadcrumb,
  hideSearch,
  region_id,
  mode = "full",
  theme = "light",
}: iBreadcrumbProps) => {
  // create a breadcrumb seperated by >
  const breadcrumbText = breadcrumb.map((item, index) => {
    // if the item is the last item in the array, don't add the >
    if (index === breadcrumb.length - 1) {
      return (
        <div className="flex gap-1" key={index}>
          {breadcrumb.length == 1 && (
            <Text
              size={13}
              leading={1.3}
              color={theme === "dark" ? "white" : "black90"}
            >
              {"<"}
            </Text>
          )}
          <Text
            size={13}
            color={theme === "dark" ? "white" : "black90"}
            leading={1.3}
            className="text-ellipsis overflow-hidden w-full whitespace-nowrap"
          >
            {item.name}
          </Text>
        </div>
      );
    }

    return (
      <React.Fragment key={index}>
        <Link to={item.url} key={index} className="flex gap-1">
          <div className="cursor-pointer" key={index}>
            <Text
              size={13}
              color={theme === "dark" ? "white" : "black90"}
              leading={1.3}
              className="whitespace-nowrap cursor-pointer hover:underline text-ellipsis "
            >
              {item.name}
            </Text>
          </div>
          <Text
            size={13}
            leading={1.3}
            color={theme === "dark" ? "white" : "black90"}
          >
            {">"}
          </Text>
        </Link>
      </React.Fragment>
    );
  });

  if (breadcrumb.length === 0) return <></>;

  if (mode === "simple")
    return (
      <div className="flex flex-1 gap-1 min-h-[15px] overflow-hidden leading-[5]">
        {breadcrumbText}
      </div>
    );

  return (
    <div className="bg-white border-b border-grey3 h-[50px] sm:h-[60px] items-center  flex">
      <div className="lg:max-w-[1000px] xl:max-w-[1120px] mx-auto px-[20px] md:px-10 lg:px-0 min-h-100 flex justify-between w-full items-center gap-2">
        <div className="flex flex-1 gap-1 min-h-[15px] overflow-hidden leading-[5]">
          {breadcrumbText}
        </div>
        {!hideSearch && (
          <div className="flex sm:min-w-[330px] lg:min-w-[400px]">
            <CommandPalette region_id={region_id} homepage={false} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BreadcrumbComponent;
